import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './HomePage/HomePage';
import LoginPage from './LoginPage';
import { JobStatusTableDetails } from 'components/JobStatusTableDetails';
import { JobStatusTableComponent } from 'components/JobStatusTableComponent';
import {
  LOGIN_PAGE,
  HOME_PAGE,
  JOB_STATUS_DETIALS,
  JOB_STATUS_PAGE,
  ASSET_UPLOAD,
  JOBS,
  JOB_DETAILS,
  ASSET_DETAIL,
  ASSET_EDIT,
  ASSET_CHECK_IN,
  NIFI_REPORT
} from '../constants/routes';
import AssetUpload from './AssetUpload/AssetUpload';
import Jobs from './Jobs/Jobs';
import UploadImageToS3WithNativeSdk from 'components/UploadImageToS3WithNativeSdk';
import JobDetails from 'componentsV2/JobsDetails/JobDetails';
import AssetDetail from './AssetDetail/AssetDetail';
import AssetEdit from './AssetEdit/AssetEdit';
import AssetCheckIn from './AssetCheckIn/AssetCheckIn';
import NifiReport from './NifiReport/NifiReport';

const Router = () => {
  return (
    <Routes>
      <Route path={HOME_PAGE} exact element={<HomePage />} />
      <Route path={LOGIN_PAGE} exact element={<LoginPage />} />
      <Route path={ASSET_UPLOAD} element={<AssetUpload />} />
      <Route path={JOBS} element={<Jobs />} exact />
      <Route path={JOB_DETAILS} element={<JobDetails />} exact />
      <Route path="/s3" element={<UploadImageToS3WithNativeSdk />} />

      <Route
        path={JOB_STATUS_DETIALS}
        exact
        element={<JobStatusTableDetails />}
      />
      <Route
        path={JOB_STATUS_PAGE}
        exact
        element={<JobStatusTableComponent />}
      />
      <Route path={ASSET_DETAIL} exact element={<AssetDetail />} />
      <Route path={ASSET_EDIT} exact element={<AssetEdit />} />
      <Route path={ASSET_CHECK_IN} element={<AssetCheckIn />} />
      <Route path={NIFI_REPORT} element={<NifiReport />} />
    </Routes>
  );
};

export default Router;
